import React, { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import Highlight from 'components/commonComponents/Highlight';

const SearchArticleItem = ({ item, highlight, handleOnClickArticle,searchtext }) => {
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = (e) => {
        e.stopPropagation();
        setExpanded(!expanded);
    };

    return (
        <Box 
            sx={{ 
                borderBottom: '1px solid #e0e0e0',
                padding: '16px 0',
                cursor: 'pointer'
            }}
            onClick={() => handleOnClickArticle(item.articleId)}
        >
            <Grid container spacing={2} alignItems="flex-start">
                {/* Left: Cover Image */}
                <Grid item xs={12} sm={3} md={2}>
                    <Box
                        component="img"
                        src={item.coverImage}
                        alt={item.articleName}
                        sx={{
                            width: '100%',
                            height: 100,
                            objectFit: 'cover',
                            borderRadius: 1
                        }}
                    />
                </Grid>

                {/* Right: Article Details */}
                <Grid item xs={12} sm={9} md={10}>
                    <Box display="flex" flexDirection="column" gap={1}>
                        {/* Title & Date */}
                        <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='wrap'>
                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                                {highlight}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {item.displayDate}
                            </Typography>
                        </Box>
                        
                        {/* Description */}
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                display: expanded ? 'block' : '-webkit-box',
                                WebkitLineClamp: expanded ? 'unset' : 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            <Highlight text={item.descriptionStriped || item.description} highlight={searchtext} />
                            
                        </Typography>

                         {/* Read More / Read Less Toggle */}
                         <Typography 
                            variant="body2" 
                            color="primary" 
                            onClick={handleExpandClick}
                            sx={{ 
                                cursor: 'pointer', 
                                mt: 0.5, 
                                display: 'inline-block', 
                                width: 'fit-content' 
                            }}
                        >
                            {expanded ? 'Read less' : 'Read more...'}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

SearchArticleItem.propTypes = {
    item: PropTypes.object.isRequired,
    highlight: PropTypes.node,
    handleOnClickArticle: PropTypes.func.isRequired
};

export default SearchArticleItem;
